import './Menu.css';
import { createRuntimeFn as _7a468 } from '@vanilla-extract/recipes/createRuntimeFn';
export var content = '_18n62i03-2-0-1';
export var group = '_18n62i04-2-0-1';
export var item = _7a468({defaultClassName:'_18n62i05-2-0-1',variantClassNames:{disabled:{true:'_18n62i06-2-0-1',false:'_18n62i07-2-0-1'}},defaultVariants:{disabled:false},compoundVariants:[]});
export var itemChildren = '_18n62i08-2-0-1';
export var label = '_18n62i02-2-0-1';
export var subChildren = '_18n62i09-2-0-1';
export var tooltip = '_18n62i00-2-0-1';
export var tooltipWrapper = '_18n62i01-2-0-1';